/**
 * shadcn Separator (Tailwind 3 "new-york"), ported per the checklist in
 * agents/CODING_STANDARDS.md -> "Styling: two systems", on a native <hr>
 * rather than @radix-ui/react-separator. Decorative by default
 * (`role="none"`, the Radix default too): pass `decorative={false}` for a
 * separator that should be announced. `orientation="vertical"` needs a
 * parent with a height.
 */
import React from 'react'

import { cn } from '../../utils/cn.js'

const Separator = React.forwardRef(
  (
    { className, orientation = 'horizontal', decorative = true, ...props },
    ref,
  ) => (
    <hr
      ref={ref}
      data-slot="separator"
      role={decorative ? 'none' : 'separator'}
      aria-orientation={
        !decorative && orientation === 'vertical' ? 'vertical' : undefined
      }
      className={cn(
        'tw-m-0 tw-shrink-0 tw-border-0 tw-bg-border',
        orientation === 'horizontal'
          ? 'tw-h-px tw-w-full'
          : 'tw-h-full tw-w-px',
        className,
      )}
      {...props}
    />
  ),
)
Separator.displayName = 'Separator'

export { Separator }
